import { FileCheck2, Ship, ShieldCheck, Anchor } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const SERVICES = [
  {
    icon: FileCheck2,
    title: "Customs Brokerage",
    desc: "Licensed customs clearance for imports and exports. We handle all documentation, tariff classification, and regulatory filings on your behalf.",
  },
  {
    icon: Ship,
    title: "Freight Forwarding",
    desc: "Sea freight, air freight, and LCL consolidation across all Ferguson's active trade corridors.",
  },
  {
    icon: ShieldCheck,
    title: "Trade Compliance Advisory",
    desc: "Country-specific regulatory guidance. We flag produce restrictions, controlled goods, and permit requirements before your cargo moves.",
  },
  {
    icon: Anchor,
    title: "Port Authority Liaison",
    desc: "Direct relationships with Kingston Port Authority and partner ports. We resolve holds and expedite releases faster than anyone in the market.",
  },
];

export const Services = () => (
  <section id="services" className="py-20 lg:py-28 bg-cream" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10">
      <Reveal>
        <p className="label-eyebrow text-gold-muted mb-3">What We Do</p>
        <h2 className="font-display font-bold tracking-tight text-2xl sm:text-3xl lg:text-4xl text-ink max-w-2xl">
          Four Disciplines. One Clearance Window.
        </h2>
      </Reveal>

      <div className="mt-10 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={i * 0.08}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="h-full rounded-2xl border border-ink/10 bg-white shadow-sm p-6 sm:p-8 hover:border-gold/50 hover:shadow-md transition-all"
              >
                <div className="h-12 w-12 rounded-xl bg-gold/10 flex items-center justify-center mb-5">
                  <Icon size={22} className="text-gold-muted" />
                </div>
                <h3 className="font-display font-semibold text-xl text-ink mb-2.5">{s.title}</h3>
                <p className="text-sm sm:text-base text-ink-soft leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
